import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { SlideAnnouncementMutationKeys } from '@/modules/client-setting/keys'
import {
	CreateSlideAnnouncementRequest,
	CreateSlideAnnouncementResponse,
} from '@/modules/client-setting/type'
import { createSlideAnnouncement } from '../../services'

interface UseMutationCreateSlideAnnouncementProps {
	payload: CreateSlideAnnouncementRequest
}

export default function useMutationCreateSlideAnnouncement(
	props?: UseBaseMutationOptions<
		CreateSlideAnnouncementResponse,
		UseMutationCreateSlideAnnouncementProps
	>,
) {
	return useMutation({
		mutationKey: [SlideAnnouncementMutationKeys.CreateSlideAnnouncement],
		mutationFn: (params) => createSlideAnnouncement(params.payload),
		...props,
	})
}
